import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../components/common/Breadcrumb';

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <div className="max-w-3xl mx-auto px-4 py-16">
      <Breadcrumb items={[{ label: t('breadcrumb.home'), to: '/' }, { label: t('breadcrumb.about') }]} />
      <h1 className="text-4xl font-bold text-white mb-8 mt-4">
        {t('about.title')} <span className="text-gradient">{t('about.titleHighlight')}</span>
      </h1>

      <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
        <p className="text-lg">
          {t('about.intro')}
        </p>

        <h2 className="text-2xl font-bold text-white">{t('about.howTitle')}</h2>
        <p>
          {t('about.howIntro')}
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>{t('about.checkAuth')}</strong></li>
          <li><strong>{t('about.checkReputation')}</strong></li>
          <li><strong>{t('about.checkContent')}</strong></li>
          <li><strong>{t('about.checkEntities')}</strong></li>
          <li><strong>{t('about.checkMO')}</strong></li>
          <li><strong>{t('about.checkCorrelation')}</strong></li>
        </ul>

        <h2 className="text-2xl font-bold text-white">{t('about.privacyTitle')}</h2>
        <p>
          {t('about.privacyText')}
        </p>

        <h2 className="text-2xl font-bold text-white">{t('about.siblingTitle')}</h2>
        <p>
          {t('about.siblingText')}{' '}
          <a href="https://scamsandbox.com" className="text-safe hover:underline">{t('about.siblingLink')}</a>
          {t('about.siblingDesc')}
        </p>
        <h2 className="text-2xl font-bold text-white">{t('about.linksTitle')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Link to="/" className="glass-card-hover p-4 block">
            <h3 className="text-safe font-semibold">{t('about.linkAnalyze')}</h3>
            <p className="text-gray-400 text-sm">{t('about.linkAnalyzeDesc')}</p>
          </Link>
          <Link to="/community" className="glass-card-hover p-4 block">
            <h3 className="text-safe font-semibold">{t('about.linkCommunity')}</h3>
            <p className="text-gray-400 text-sm">{t('about.linkCommunityDesc')}</p>
          </Link>
          <Link to="/history" className="glass-card-hover p-4 block">
            <h3 className="text-safe font-semibold">{t('about.linkHistory')}</h3>
            <p className="text-gray-400 text-sm">{t('about.linkHistoryDesc')}</p>
          </Link>
          <a href="/faq/" className="glass-card-hover p-4 block">
            <h3 className="text-safe font-semibold">{t('about.linkFAQ')}</h3>
            <p className="text-gray-400 text-sm">{t('about.linkFAQDesc')}</p>
          </a>
        </div>
      </div>
    </div>
  );
}
